<template>
  <span
    v-if="globalSearchKeyword"
    class="btn-search-suggestion mr-1 t-sm btn badge-primary--blue-bordered mt-3 text-left"
    @click.prevent="clicked"
  >
    <i class="fa fa-search t-secondary mr-2" />Search for <b>{{ globalSearchKeyword }}</b>
  </span>
</template>

<script>
import MPService from '@/services/mixpanel'

export default {
  name: 'searchSuggestionButton',
  props: {
    scope: {
      type: String,
      required: true
    }
  },
  methods: {
    clicked () {
      MPService.trackEvent('reuse_keyword_in_scoped_search', {
        type: this.scope,
        keyword: this.globalSearchKeyword
      })
      this.$emit('clicked', this.globalSearchKeyword)
    }
  }
}
</script>
